import { render } from "./forgot-password.html?vue&type=template&id=2a29352f&ts=true&external"
import script from "./forgot-password.ts?vue&type=script&lang=ts&external"
export * from "./forgot-password.ts?vue&type=script&lang=ts&external"

import "./forgot-password.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__